
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetPtype4Off as ObiMosfetPtype4OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ptype-4-off.js';
 
 
 

 
 export const ObiMosfetPtype4Off = createComponent({
   react: React,
   tagName: 'obi-mosfet-ptype-4-off',
   elementClass: ObiMosfetPtype4OffElement,
   events: {
     
   }
  });
 
 